import { Variants } from 'framer-motion';

import teamDayDemo from '../../assets/demo/team-day.mp4';
import teamSettingsDemo from '../../assets/demo/team-settings.mp4';
import teamTasksDemo from '../../assets/demo/team-tasks.mp4';

export const TEAM_NAME_MAX_LENGTH = 80;
export type TeamDetailSection = 'day' | 'tasks' | 'settings';
export type TeamSettingsSection =
  | 'rename'
  | 'sharedCalendar'
  | 'sharedTodos'
  | 'sharedEnergy'
  | 'projects'
  | 'members'
  | 'delete';

export const TEAM_SETTINGS_SECTION_ID_MAP: Record<TeamSettingsSection, string> = {
  rename: 'team-settings-rename',
  sharedCalendar: 'team-settings-shared-calendar',
  sharedTodos: 'team-settings-shared-todos',
  sharedEnergy: 'team-settings-shared-energy',
  projects: 'team-settings-projects',
  members: 'team-settings-members',
  delete: 'team-settings-delete',
};

export const TEAM_DEFAULT_DETAIL_SECTION: TeamDetailSection = 'day';

export const TEAM_BETA_FEATURES = [
  {
    i18nKey: 'tasks',
    videoSrc: teamTasksDemo,
  },
  {
    i18nKey: 'teamDay',
    videoSrc: teamDayDemo,
  },
  {
    i18nKey: 'sharing',
    videoSrc: teamSettingsDemo,
  },
];

export const isTeamDetailSection = (section?: string): section is TeamDetailSection => {
  return section === 'day' || section === 'tasks' || section === 'settings';
};

export const teamCardVariants: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
    },
  },
  exit: { opacity: 0, y: -8, transition: { duration: 0.16 } },
};

export const getTeamInitials = (teamName: string) => {
  const normalizedTeamName = teamName.trim();
  if (!normalizedTeamName) {
    return 'TM';
  }

  const parts = normalizedTeamName.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
};
